import { Absence } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { ABSENCES_QUERY_KEY, ABSENCES_UPCOMING_QUERY_KEY, ABSENCES_URL } from './queryConstants'
import dayjs from 'dayjs'
import { getQueryParams } from 'utils/getQueryParams'

type UseAbsencesUpcomingListProps = {
  users?: [string | undefined]
  absenceType?: string
}

type UseAbsencesUpcomingListReturn = {
  upcomingAbsences: Absence[]
  isUpcomingAbsencesLoading: boolean
}

export const useAbsencesUpcomingList = ({
  users,
  absenceType,
}: UseAbsencesUpcomingListProps): UseAbsencesUpcomingListReturn => {
  const upcomingAbsencesQueryParams = getQueryParams({
    startDate: dayjs().add(1, 'day').startOf('day').toISOString(),
    users,
    absenceType,
  })

  const { data: upcomingAbsencesData, isLoading: isUpcomingAbsencesLoading } =
    useQuery(
      [ABSENCES_QUERY_KEY, ABSENCES_UPCOMING_QUERY_KEY, users?.join('-'), absenceType],
      () =>
        getJSON({
          url: `${ABSENCES_URL}?${upcomingAbsencesQueryParams}`,
          isRota: true,
        }),
      { enabled: true }
    )

  return {
    upcomingAbsences: upcomingAbsencesData?.data || [],
    isUpcomingAbsencesLoading,
  }
}
